import { render } from "./OdontogramPreview.vue?vue&type=template&id=3f8bf83e&scoped=true"
import script from "./OdontogramPreview.vue?vue&type=script&lang=js"
export * from "./OdontogramPreview.vue?vue&type=script&lang=js"

import "./OdontogramPreview.vue?vue&type=style&index=0&id=3f8bf83e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8bf83e"]])

export default __exports__